import { environmentBase } from './config';

export const environment = {
  ...environmentBase,
  production: true,
  ApiBaseUrl: '/api-prod',
  EnableQuoteFeature: false,
};
